import { useAuth0 } from '@auth0/auth0-react';
import MainWindow from '../../app_layout/main_window/MainWindow';
import ChatWindow from '../../app_layout/chat_window/ChatWindow';
import SideBar from '../../app_layout/sidebar/SideBar';
import APP_WINDOW_CONFIG from '../../app_layout/layout_config';

// imports relevant for HTTP calls
import DisplayException from '../../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import {SERVER_URL, WEBSOCKET_URL} from '../../config_server_url';

// import user session information
import UserSessionContext from '../../user_session/context_user_session';
import { SetSessionInfo_OnDeleteCurrentProject, SetSessionInfo_OnDeleteCurrentCampaign } from '../../user_session/session_info_utils';

import CampaignTree from '../../current_campaign/campaign_tree_view/CampaignTree';
import CyclePrev from '../../current_campaign/optimization_cycles/CyclePrev'
import CycleNext from '../../current_campaign/optimization_cycles/CycleNext'
import InfoPopup from '../../popup_windows/InfoPopup';

import { useNavigate } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';



function PageProjectTreeView() {

    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    // This Component requires to fetches data on first load -> setIsloading(true);
    // This Component does not fetch data on first load -> setIsloading(false);
    const [isLoading, setIsLoading] = useState(true);

    // ------------------ Load User Session Information ---------------------------------
    const usr_session_ctx = useContext(UserSessionContext);
    const { user } = useAuth0();
    const [broadcastProject, setBroadcastProject] = useState([]); //get session notifications via web sockets
    const [broadcastCampaign, setBroadcastCampaign] = useState([]); //get session notifications via web sockets

    // ------------------ Add User Session Websockets For Notification Events Across All Tenant (Workspace) Members -----------------------------

    useEffect(() => {
        // Create WebSocket connection`${SERVER_URL}/all_projects/load/`
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_project/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        // Connection opened
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
          };
        // Listen for messages
        ws.onmessage = (event) => {
        //   console.log('Message received:', event.data);
          let parser = event.data.split('__');
          let sender = parser[0]
          let type = parser[1].split('.')[1]
          let project_uuid = parser[2]
          if (type === 'ProjectDelete'){
            if(project_uuid === usr_session_ctx.session_info.uuid_current_project) {
                let new_broadcast = (<>{sender} has deleted <strong>your current project uuid:{project_uuid}</strong></>);
                usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentProject(usr_session_ctx);
                handleUpdateUserSession()
                setBroadcastProject(prevBroadcast => [...prevBroadcast, new_broadcast]);
            }
          }
        };
        // Connection closed
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
          ws.close();
        };
      }, []); // Effect runs when tenant_id or user_id changes


    useEffect(() => {
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_campaign/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
        };
        // Listen for messages
        ws.onmessage = (event) => {
            // console.log('Message received:', event.data);
            let parser = event.data.split('__');
            let sender = parser[0]
            let type = parser[1].split('.')[1]
            let project_uuid = parser[2]
            let campaign_uuid = parser[3]
            if (project_uuid === usr_session_ctx.session_info.uuid_current_project){
                if (type === 'UpdateCampaignTitle'){
                    let new_broadcast = (<>{sender} has updated the campaign title for campaign uuid:{campaign_uuid}.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                if (type === 'CampaignCreate'){
                    let new_broadcast = (<>{sender} has created a new campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                if (type === 'CampaignDelete'){
                    if(campaign_uuid === usr_session_ctx.session_info.uuid_current_opt_campaign) {
                        let new_broadcast = (<>{sender} has deleted <strong>your current campaign uuid:{campaign_uuid}</strong></>);
                        usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx);
                        handleUpdateUserSession()
                        setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    }
                    else{
                        let new_broadcast = (<>{sender} has deleted campaign uuid:{campaign_uuid}</>);
                        setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    }
                }
            if (type === 'CampaignCycleCreate'){
                let new_broadcast = (<>{sender} has created a new cycle for campaign uuid:{campaign_uuid}</>);
                setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
            if (type === 'CampaignCycleDelete'){
                let new_broadcast = (<>{sender} has deleted a cycle for campaign uuid:{campaign_uuid}</>);
                setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
            if (type === 'CampaignDataUpload'){
                    let new_broadcast = (<>{sender} has uploaded new data for campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
            if (type === 'CampaignDataRemoved'){
                let new_broadcast = (<>{sender} has removed data from campaign uuid:{campaign_uuid}</>);
                setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
            }
        };
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
        ws.close();
        };
    }, []); // Effect runs when tenant_id or user_id changes
  



    function handleUpdateUserSession() {
        setIsLoading(true);
        let session_update = {key: 'session_info', value: usr_session_ctx.session_info}
        fetch(`${SERVER_URL}/user_session/update_field/`, {method: 'PUT',
                                                           headers:{'Content-Type':'application/json',
                                                                    'auth0_user': user.sub,
                                                                    'uuid_tenant': usr_session_ctx.uuid_tenant }, 
                                                           body:JSON.stringify(session_update)
        })
        .then((res) => {
        if(!res.ok) {
            throw new Error(`HTTP error ${res.status}`);
        }
            return res.json();
        })
        .then((data) => {
            setIsLoading(false);
        })
            .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
   }


    // ------------------ General Window Layout -----------------------------
        
    const [canvasSize, setCanvasSize] = useState({width: 0, height: 0});
    const [layout, setLayout] = useState({sidebar:0, main: 0, chat: 0});
    const [toggleSideBar, setToggleSideBar] = useState(false);

    useEffect(() => {
        function handleResize() {
            let window_height = window.innerHeight;
            let window_width = window.innerWidth;
            let canvas_height = window_height - APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = (window_width - sidebar)*APP_WINDOW_CONFIG.CHAT_WIDTH_RELATIVE;
            chat = Math.max (chat, APP_WINDOW_CONFIG.MIN_CHAT_WIDTH_PX);
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setCanvasSize({width: window_width, height: canvas_height});
            // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
            if(toggleSideBar){
                sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
                main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            }
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        // Set initial height
        handleResize();
        // Add event listener to handle window resize
        window.addEventListener('resize', handleResize);
        // Remove event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [toggleSideBar]); // Empty dependency array ensures the effect only runs once


    function handleToggle() {
        // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
        if(!toggleSideBar){
            let window_width = window.innerWidth;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
            let chat = layout.chat;
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        else
        {
            let window_width = window.innerWidth;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = layout.chat;
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        setToggleSideBar(!toggleSideBar);
    }


// ------------------ Side Bar Content -----------------------------

    let sidebar = (<>
        <SideBar width={layout.sidebar} 
                toggle={toggleSideBar} 
                handle_toggle={handleToggle} 
                active_link='project_tree_view' >
        </SideBar>
    </>)


// ------------------ Main Window Content ----------------------------

    const [campaignId, setCampaignId] = useState(-1);
    const [campaignTree, setCampaignTree] = useState([])
    const [campaignInfo, setCampaignInfo] = useState([])
    const [prevActive, setPrevActive] = useState(false);
    const [nextActive, setNextActive] = useState(false);
    const [numCampaigns, setNumCampaigns] = useState(1);
    const [existingCampaigns, setExistingCampaigns] = useState(false);


    const navigate = useNavigate();



    function load_tree(){
        setIsLoading(true); // Set loading state to true when fetch begins    // server retunrs -> cols about what info is shown. 
        const uuid_current_project = usr_session_ctx.session_info.uuid_current_project;
        fetch(`${SERVER_URL}/current_project/load_all_campaign_tree_views/`, {method: 'POST',
                                                   headers:{'Content-Type':'application/json',
                                                            'uuid_tenant': usr_session_ctx.uuid_tenant },
                                                   body:JSON.stringify(uuid_current_project)
                                                 })
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((loaded_tree) => {
            setIsLoading(false); 
            setCampaignTree(loaded_tree.data.all_campaign_tree_views)
            setCampaignInfo(loaded_tree.data.all_campaign_info)
            let num_campaigns = loaded_tree.data.all_campaign_tree_views.length
            setNumCampaigns(num_campaigns)
            if (num_campaigns === 0) {
                setExistingCampaigns(false);
                setCampaignId(-1);
            } else {
                setCampaignId(0);
                setExistingCampaigns(true);
            }
        })
        .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
    }

    // Fetch All Projects
    useEffect(() => {
        load_tree()
    }, []);


    useEffect(() => {
        if (campaignId > 0) {setPrevActive(true);}
        else {setPrevActive(false);}
        if (campaignId < numCampaigns-1) {setNextActive(true);}
        else {setNextActive(false);}
    }, [campaignId, numCampaigns]);


    function handleNextCampaign(){
        setCampaignId(campaignId+1);
    }
   
    function handlePrevCampaign(){
        setCampaignId(campaignId-1);
    }



    let mainWindow = (<></>);
    // Exection and Error Messeges Get Priority and Are Evaluated Before Anything els
    if(Exception){
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <DisplayException>
                        {ExceptionMessage}
                    </DisplayException>  
                </MainWindow>
            </>);
    }

    let cycleNav = (<></>);
    if(numCampaigns > 0) {
        cycleNav = (<>
            <div style = {{'marginTop': '20px', 'marginBottom': '0px', 'border':'none', 'outline':'none', 'padding':'0px', display:'flex', alignItems:'center',
                     'fontSize': '24px', 'fontWeight':'bold', position: 'relative', left:'3%', width:'94%'}} >
                <CyclePrev handleClick={handlePrevCampaign} active={prevActive}/>   
                    <div style={{margin:'0px', marginRight:'9px'}}>Campaign {campaignId+1} of {numCampaigns}</div>
                <CycleNext handleClick={handleNextCampaign} active={nextActive}/>
            </div>
        </>);
    }

    if (!isLoading && !Exception && existingCampaigns && broadcastProject.length === 0 && broadcastCampaign.length === 0) { 
        mainWindow = (<>
            <MainWindow width={layout.main} >
                {cycleNav}
                <h3 style = {{marginLeft:'0px', marginBottom:'0px', marginTop:'20px', position: 'relative', left:'3%'}} >Campaign Tree</h3>
                <p style={{position: 'relative', left:'3%', marginTop:'3px', marginBottom:'0px', fontSize:'14px'}}>Campaign Title: {campaignInfo[campaignId].title}</p>
                <p style={{position: 'relative', left:'3%', marginTop:'3px', marginBottom:'5px', fontSize:'14px'}}>Campaign UUID: {campaignInfo[campaignId].uuid}</p>
                {/* <div style={{position: 'relative', left: '50%',  transform: 'translate(-50%,0% )', width:'94%', paddingTop:'10px', height:'80%', overflow:'auto', border:'1px solid var(--aixelo-red)'}}> */}
                    <CampaignTree 
                        height='100%'
                        tree={campaignTree[campaignId]}/>
                {/* </div> */}
            </MainWindow>
        </>);
    }

    if (!isLoading && !Exception && !existingCampaigns && broadcastProject.length === 0 && broadcastCampaign.length === 0) { 
        mainWindow = (<>
            <MainWindow width={layout.main} >
                <div style={{fontSize:'18px', position:'relative', textAlign:'center', height:'fit-content', marginTop:'50px', width:'100%'}} >
                The project does not yet contain any optimization campaign.
                </div>               
            </MainWindow>
        </>);
    }



    if (!isLoading && !Exception && broadcastCampaign.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setBroadcastCampaign(prevBroadcast => []); load_tree();} } >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastCampaign.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }


    if (!isLoading && !Exception && broadcastProject.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setBroadcastProject(prevBroadcast => []); navigate('/')} } >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastProject.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }


    if (isLoading && !Exception) {   
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%', border:'1px solid black'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </MainWindow>
            </>);
       }


// ------------------ Return All Components ----------------------------

    // Show Sidebar, MainWindow and ChatWindow
    return(
        <>
        <div style={{position:'relative', display:'grid', gridTemplateColumns: 'auto auto auto', overflow: 'hidden', left:`${APP_WINDOW_CONFIG.OFFSET_WINDOW_LEFT_PX}px`, top:`${APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX}px`, height:canvasSize.height, width:'100%'}}>
            {sidebar}
            {mainWindow}
            <ChatWindow width={layout.chat}/>
        </div>    
        </>
    );

}


export default PageProjectTreeView;